import { render, staticRenderFns } from "./OsAssignedReportCategoriesCheckboxView.vue?vue&type=template&id=0a557ecd&scoped=true"
import script from "./OsAssignedReportCategoriesCheckboxView.vue?vue&type=script&lang=ts"
export * from "./OsAssignedReportCategoriesCheckboxView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a557ecd",
  null
  
)

export default component.exports